import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
  postApiWithoutAuthorization,
} from "../ApiMethod/ApiMethod";

export const CurrentBlogData = async (params) => {
  const url = `${BaseUrl}/Blog`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
export const BlogCategoryList = async () => {
  const url = `${BaseUrl}/BlogCategoryList`;
  const res = await getApiWithAuthorization(url);
  return res;
};




// ------------------------New Api Endpoints----------------------------
export const GetBlogCategoryList = async (AppLangID) => {
  const url = `${NewUpdatedBaseUrl}/Blog/GetBlogCategoryList?AppLangID=${AppLangID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};

export const GetBlogDetailsBySlug = async (AppLangID, BlogSlug) => {
  const url = `${NewUpdatedBaseUrl}/Blog/GetBlogDetailsBySlug?BlogSlug=${BlogSlug}&AppLangID=${AppLangID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};
export const GetBlogLookupList = async (params, AppLangID, BlogCatID) => {
  let url;
  if (BlogCatID === null || BlogCatID === undefined || BlogCatID === "") {
    url = `${NewUpdatedBaseUrl}/Blog/GetBlogLookupList?BlogCatID=&AppLangID=${AppLangID}`;
  } else {
    url = `${NewUpdatedBaseUrl}/Blog/GetBlogLookupList?BlogCatID=${BlogCatID}&AppLangID=${AppLangID}`;
  }

  const res = await postApiWithAuthorization(url, params);
  return res;
};


export const GetWebAppBlogList = async (params, BlogCatID, AppLangID) => {

  let url;
  if (BlogCatID === null || BlogCatID === undefined || BlogCatID === "") {
    url = `${NewUpdatedBaseUrl}/Blog/GetWebAppBlogList?BlogCatID=&AppLangID=${AppLangID}`;
  } else {
    url = `${NewUpdatedBaseUrl}/Blog/GetWebAppBlogList?BlogCatID=${BlogCatID}&AppLangID=${AppLangID}`;
  }

  const res = await postApiWithAuthorization(url, params);
  return res;
};